var icon = require('vue-svgicon')
icon.register({
  'ks-icon-contact-phone': {
    width: 128,
    height: 128,
    viewBox: '0 0 128 128',
    data: '<path pid="0" d="M111 22H17.67a9.34 9.34 0 0 0-9.34 9.33v65.34a9.34 9.34 0 0 0 9.34 9.33H111a9.33 9.33 0 0 0 9.33-9.33V31.33A9.33 9.33 0 0 0 111 22M45.67 36a14 14 0 1 1-14 14 14 14 0 0 1 14-14m28 56h-56v-4.67c0-9.33 18.66-14.46 28-14.46s28 5.13 28 14.46V92m18-18.67h7.7l7 9.34L97 92a35.69 35.69 0 0 1-12.69-18.67 33.88 33.88 0 0 1 0-18.66A35.53 35.53 0 0 1 97 36l9.33 9.33-7 9.34h-7.7a27.52 27.52 0 0 0 0 18.66z"/>'
  }
})
